/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity, enumeration } from '@gh/core-data';
import { ComponentItemFilter } from './component-item-finder-rest.service';
import { ComponentItemFilterMode } from './component-item-type.enum';

export const ComponentItemFilterMapper = entity<ComponentItemFilter>({
  searchType: enumeration(ComponentItemFilterMode),
});
